<template>
  <div>
    <!-- 面包屑导航 -->
  <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>工作台</el-breadcrumb-item>
      <el-breadcrumb-item>我的工作台</el-breadcrumb-item>
      <el-breadcrumb-item>项目预决算统计</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-select v-model="keywords.bomsn" placeholder="请选择项目" class="select" style="width: 150px;">
              <el-option label="请选择项目" value="0"></el-option>
              <el-option
                v-for="item in projectlist" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="keywords.projecttimebegin" type="date" placeholder="选择开始日期" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="keywords.projecttimeend" type="date" placeholder="选择结束日期" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            总金额:{{Projectshijipricetotal}};所选时间范围内金额:{{Projectshijipricetime}}
          </el-form-item>
        </el-form>
        <!-- 查询 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Projectname" label="项目" header-align="center" align="center" min-width="7%"></el-table-column>
          <el-table-column prop="Jigouname" label="部门" header-align="center" align="center" min-width="7%"></el-table-column>
          <el-table-column prop="Projecttime" label="日期" header-align="center" align="center" min-width="7%"></el-table-column>
          <el-table-column prop="Projectproductname" label="品名" header-align="center" align="center" min-width="10%"></el-table-column>
          <el-table-column prop="Projectyujiprice" label="预算单价" header-align="center" align="center" min-width="6%"></el-table-column>
          <el-table-column prop="Projectnum" label="数量" header-align="center" align="center" min-width="4%"></el-table-column>
          <el-table-column prop="Projectyujidays" label="预计完成天数" header-align="center" align="center" min-width="7%"></el-table-column>
          <el-table-column prop="Projectshijidays" label="实际完成时间" header-align="center" align="center" min-width="7%"></el-table-column>
          <el-table-column prop="Projectsuppliername" label="供应商名称" header-align="center" align="center" min-width="7%"></el-table-column>
          <el-table-column prop="Projectphone" label="联系电话" header-align="center" align="center" min-width="5%"></el-table-column>
          <el-table-column prop="Projectshijiprice" label="实际支付单价" header-align="center" align="center" min-width="9%"></el-table-column>
          <el-table-column prop="Projectpaystatuss" label="是否支付" header-align="center" align="center" min-width="6%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" header-align="center" align="center" min-width="10%"></el-table-column>
        </el-table>

        <!-- 分页 -->
<!--        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="8"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div> -->
      </el-tab-pane>
      <!-- 清单列表 end -->

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyWorkprojectbudgetstatistical',
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      projectlist: [],
      // 筛选条件
      keywords: {
        bomsn: '103-0000-0002',
        projecttimebegin: '',
        projecttimeend: ''
      },
      Projectshijipricetotal: '0',
      Projectshijipricetime: '0'
    }
  },
  mounted () {
    this.keywords.projecttimebegin = Vue.prototype.FunGetTimeStringShortFirst()
    this.keywords.projecttimeend = Vue.prototype.FunGetTimeStringShort()

    this.apiGetWorkprojectList()
    this.apiGetWorkprojectbudgetstatisticalList()
  },
  methods: {
    changeRsljigouInternal (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    clickreturn () {
      this.activeName = 'first'
      this.apiGetWorkprojectbudgetstatisticalList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetWorkprojectbudgetstatisticalList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetWorkprojectbudgetstatisticalList()
    },
    apiGetWorkprojectbudgetstatisticalList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        bomsn: that.keywords.bomsn,
        projecttimebegin: that.keywords.projecttimebegin,
        projecttimeend: that.keywords.projecttimeend
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWorkprojectbudgetstatisticalList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
            that.Projectshijipricetotal = response.data.Projectshijipricetotal
            that.Projectshijipricetime = response.data.Projectshijipricetime
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetWorkprojectList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWorkprojectList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.projectlist = []
            response.data.List.filter((item1, i1) => {
              if (item1.Bomtype <= 1) {
                that.projectlist.push({ value: item1.Bomsn, label: item1.Name })
              }
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>

  .item {
    margin-top: 10px;
    margin-right: 40px;
  }

/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}

.box-cardprimary{
    margin-top: 0px;
    background: #409eff;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.box-cardwarning{
    margin-top: 0px;
    background: #ebb562;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.box-carddanger{
    margin-top: 0px;
    background: #f56c6c;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.userList{
    display: flex;
    align-items: center;
    .user{
        color:#ffffff;
        margin: 0 20px 0 0;
    }
    .number{
        font-size: 30px;
        margin: 0;
        font-weight: bold;
        color:#ffffff;
    }
}
</style>
